import { render } from "./ModalEdicaoMeuPerfilEndereco.vue?vue&type=template&id=fd1eb192&ts=true"
import script from "./ModalEdicaoMeuPerfilEndereco.vue?vue&type=script&lang=ts"
export * from "./ModalEdicaoMeuPerfilEndereco.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__